import React from "react";
import classNames from "classnames/bind"

import styles from "./section-divider.module.scss"

const cx = classNames.bind(styles)

export const SectionDivider = () => {
    return (
        <div className={cx(["section-divider", "animate__animated", "animate__fadeIn", "animate__delay-0.1s"])}></div>
    )
}